export default "__VITE_ASSET__Dhz8uCCk__"